import axios from 'axios';

export interface IParsedApiError {
  statusCode?: number;
  errorCode?: string;
  message: string;
  requestUrl?: string;
}

export function parseApiError(error: unknown): IParsedApiError {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as {
      error?: string;
      message?: string;
    } | undefined;

    return {
      statusCode: error.response?.status,
      errorCode: data?.error,
      message: data?.message || error.message || 'Request failed',
      requestUrl: error.config?.url,
    };
  }

  if (error instanceof Error) {
    return { message: error.message };
  }

  return { message: String(error || 'Unknown error') };
}
